import { setCookie, getCookie } from './../shared/cookieHelper';


window.showTerms = function (element) {
   
    $('#terms-text').html(element);
    $('#modal-terms').show();
}

window.copyToClipboard = function (element) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text()).select();
    document.execCommand("copy");
    $temp.remove();
    alert("Copied");
}



window.SpecLockClearHomePage = function () {
    $('#street_number').val('');
    $('#route').val('');
    $('#locality').val('');
    $('#administrative_area_level_1').val('');
    $('#country').val('');
    $('#postal_code').val('');
    $('#state_code').val('');
    $('#county_code').val('');
    $("#btnStarted").attr("disabled", "disabled");
    $("#btnStarted").addClass("disabled");
    $("#btnStartedMob").attr("disabled", "disabled");
    $("#btnStartedMob").addClass("disabled");
};
window.GetDataFromModal = function () {
    $('#street_number').val($('#txtStreetNo').val());
    $('#route').val($('#txtStreet').val());
    $('#locality').val($('#txtCity').val());    
    $('#postal_code').val($('#txtZip').val());
   
};
window.thisFileUpload = function () {
    document.getElementById("listingimagefile").click();
};

$(function () {

    if ($('#speclock_home_page').length) {
        var $loading = $('#ll_loading-div').hide();
        var $loadingform = $('#ll_loading-div-form').hide();

      

        $('#selectState').on('change', function (e) {
            var optionSelected = $("option:selected", this);            
            var stateCode = optionSelected.text()
            document.getElementById('state_code').value = this.value;
            $('#administrative_area_level_1').val(stateCode);
            var loc = $("#prefixurl").val();
            //var form = new FormData();
            //form.append("formstate", stateCode);

            $.ajax({
                url: loc + '/get-counties/' + stateCode,
                type: 'GET',
                //cache: false,
                //contentType: false,
                //processData: false,
                //data: form,
                beforeSend: function () {
                    $loadingform.show();
                },
                success: function (response) {
                    $loadingform.hide();
                    let dropdown = document.getElementById('selectCounty');
                    dropdown.length = 0;

                    let defaultOption = document.createElement('option');
                    defaultOption.text = 'Choose County';

                    dropdown.add(defaultOption);
                    dropdown.selectedIndex = 0;
                    var obj = jQuery.parseJSON(response);
                    let option;

                    for (let i = 0; i < obj.length; i++) {
                        option = document.createElement('option');
                        option.text = obj[i].Name;
                        option.value = obj[i].Code;
                        dropdown.add(option);
                    }
                }
            });                      
        });

        $('#selectCounty').on('change', function (e) {
            var optionSelected = $("option:selected", this);
            var valueSelected = this.value;
            var textSelected = optionSelected.text()
            document.getElementById('county_code').value = this.value;
            $('#administrative_area_level_2').val(textSelected);

        });
        $('#btnFormStart').click(function (e) {

            $("#form-address").validate();
            if ($('#form-address').valid()) {
                e.preventDefault();
                GetDataFromModal();
                //getstatedetailsmanual();
                var form = new FormData();
                setCookie("ll_state_error", "no", 1);
                var sNumber = $("#street_number").val();
                var sName = $("#route").val();
                var line1 = $("#street_number").val() + " " + $("#route").val() + ", ";
                if (sNumber == "" && sName == "")
                    line1 = "";

                var autocomplete = line1 +  document.getElementById('locality').value + ", " + $("#administrative_area_level_1").val();
                form.append("autocomplete", autocomplete);
                form.append("state_code", document.getElementById('state_code').value);
                form.append("county_code", document.getElementById('county_code').value);
                form.append("locality", document.getElementById('locality').value);
                form.append("administrative_area_level_1", $("#administrative_area_level_1").val());
                var s = $("#administrative_area_level_1").val();
                form.append("state_lisenced", $("#state_lisenced").val());
                var sl = $("#state_lisenced").val();
                form.append("member_id", $("#member_id").val());
                form.append("street_number", $("#street_number").val());
                form.append("route", $("#route").val());
                form.append("postal_code", $("#postal_code").val());
                form.append("branch_orgid", $("#branch_orgid").val());
                var loc = $("#prefixurl").val();
                setCookie("speclock_prefix_url", loc, 1);
                setCookie("autocomplete", document.getElementById('autocomplete').value, 1);
                if (sl.indexOf(s) < 0) {
                    setCookie("speclock_state", s, 1);
                    setCookie("speclock_state_error", "yes", 1);
                    window.location.href = loc;
                }
                else {
                    $.ajax({
                        url: loc + '/RateOptions',
                        type: 'POST',
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: form,
                        beforeSend: function () {
                            $loading.show();
                        },
                        success: function (response) {
                            $loading.hide();
                            if (response == "ok")
                                window.location.href = loc + "/SearchRateOptions";
                            else
                                window.location.href = loc;
                        }
                    });
                }
            }
            else
                return false;
        });

        //$("#btnStarted").attr("disabled", "disabled");
        //$("#btnStarted").addClass("disabled");
        //$("#btnStartedMob").attr("disabled", "disabled");
        //$("#btnStartedMob").addClass("disabled");
        //var script = document.createElement('script');
        //script.type = 'text/javascript';
        //script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMapSpecLock';
        //script.async = true;
        //document.body.appendChild(script);

      

        //$('#btnStartedMob').click(function (e) {
        //    e.preventDefault();
        //    var form = new FormData();
        //    setCookie("ll_state_error", "no", 1);
        //    form.append("autocomplete", document.getElementById('autocomplete').value);
        //    form.append("state_code", document.getElementById('state_code').value);
        //    form.append("county_code", document.getElementById('county_code').value);
        //    form.append("locality", document.getElementById('locality').value);
        //    form.append("administrative_area_level_1", $("#administrative_area_level_1").val());
        //    var s = $("#administrative_area_level_1").val();
        //    form.append("state_lisenced", $("#state_lisenced").val());
        //    var sl = $("#state_lisenced").val();
        //    form.append("member_id", $("#member_id").val());
        //    form.append("street_number", $("#street_number").val());
        //    form.append("route", $("#route").val());
        //    form.append("postal_code", $("#postal_code").val());
        //    form.append("branch_orgid", $("#branch_orgid").val());
        //    var loc = $("#prefixurl").val();
        //    setCookie("speclock_prefix_url", loc, 1);
        //    setCookie("autocomplete", document.getElementById('autocomplete').value, 1);
        //    if (sl.indexOf(s) < 0) {
        //        setCookie("ll_state", s, 1);
        //        setCookie("ll_state_error", "yes", 1);
        //        window.location.href = loc;
        //    }
        //    else {
        //        $.ajax({
        //            url: loc + '/RateOptions',
        //            type: 'POST',
        //            cache: false,
        //            contentType: false,
        //            processData: false,
        //            data: form,
        //            beforeSend: function () {
        //                $loading.show();
        //            },
        //            success: function (response) {
        //                $loading.hide();
        //                if (response == "ok")
        //                    window.location.href = loc + "/SearchRateOptions";
        //                else
        //                    window.location.href = loc;
        //            }
        //        });
        //    }
        //});

        //$('#btnStarted').click(function (e) {
        //    e.preventDefault();
        //    var form = new FormData();
        //    setCookie("ll_state_error", "no", 1);
        //    form.append("autocomplete", document.getElementById('autocomplete').value);
        //    form.append("state_code", document.getElementById('state_code').value);
        //    form.append("county_code", document.getElementById('county_code').value);
        //    form.append("locality", document.getElementById('locality').value);
        //    form.append("administrative_area_level_1", $("#administrative_area_level_1").val());
        //    var s = $("#administrative_area_level_1").val();
        //    form.append("state_lisenced", $("#state_lisenced").val());
        //    var sl = $("#state_lisenced").val();
        //    form.append("member_id", $("#member_id").val());
        //    form.append("street_number", $("#street_number").val());
        //    form.append("route", $("#route").val());
        //    form.append("postal_code", $("#postal_code").val());
        //    form.append("branch_orgid", $("#branch_orgid").val());
        //    var loc = $("#prefixurl").val();
        //    setCookie("speclock_prefix_url", loc, 1);
        //    setCookie("autocomplete", document.getElementById('autocomplete').value, 1);
        //    if (sl.indexOf(s) < 0) {
        //        setCookie("ll_state", s, 1);
        //        setCookie("ll_state_error", "yes", 1);
        //        window.location.href = loc;
        //    }
        //    else {
        //        $.ajax({
        //            url: loc + '/RateOptions',
        //            type: 'POST',
        //            cache: false,
        //            contentType: false,
        //            processData: false,
        //            data: form,
        //            beforeSend: function () {
        //                $loading.show();
        //            },
        //            success: function (response) {
        //                $loading.hide();
        //                if (response == "ok")
        //                    window.location.href = loc + "/SearchRateOptions";
        //                else
        //                    window.location.href = loc;
        //            }
        //        });
        //    }
        //});

        $('#modal-confirmation').keypress(function (e) {
            if (e.keyCode == 13) {
                $('#btnConfirm').click();
            }
        });

        $('#btnConfirm').click(function (e) {
            e.preventDefault();
           
            var loc = $("#prefixurl").val();
            setCookie("speclock_prefix_url", loc, 1);

           
                $.ajax({
                    url: loc + '/check?id=' + $("#txtConfirmationNumber").val(),
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    beforeSend: function () {
                        $loading.show();
                    },
                    data: "",
                    success: function (response) {
                        $loading.hide();
                        window.location.href = loc + '/confirmation?id=' + $("#txtConfirmationNumber").val()
                    }
                });
            
        });

        $('#btnResent').click(function (e) {
            e.preventDefault();

            var loc = $("#prefixurl").val();
            setCookie("speclock_prefix_url", loc, 1);
            var formData = new FormData();
            formData.append("resentemail", $("#txtREmail").val());
            $.ajax({
                url: loc + '/CheckAndResend',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                beforeSend: function () {
                    $loading.show();
                },
                success: function (response) {
                    $loading.hide();
                    if (response == "ok") {
                        window.location.href = loc + '/information?status=ok';
                    }
                    else {
                        window.location.href = loc + '/information?status=error';
                    }
                }
            });

        });

        $('#btnAlreadyExist').click(function (e) {
            e.preventDefault();

            var loc = $("#prefixurl").val();
            setCookie("speclock_prefix_url", loc, 1);
            
            $.ajax({
                url: loc + '/AlreadyExist',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: "",
                beforeSend: function () {
                    $loading.show();
                },
                success: function (response) {
                    $loading.hide();
                    if (response == "ok") {
                        window.location.href = loc + '/SearchRateOptions';
                    }
                    //else {
                    //    window.location.href = loc + '/information?status=error';
                    //}
                }
            });

        });
    }

    if ($('#speclock_search_rate_options_page').length) {
        var $loading = $('#ll_loading-div');

        $(document).ready(function () {
            $loading.hide();
            document.getElementById("hdnNoOfUnits").value = 1;
            document.getElementById("hdnLockTerm").value = 60;
            $('#noUnits').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                document.getElementById("hdnNoOfUnits").value = this.value;
            });
            $('#lockTerm').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                document.getElementById("hdnLockTerm").value = this.value;
            });
        });

        $('#builderConcession').on('focus', function (e) {
            if ($(this).val() == "0.000") {
                $(this).val("");
            }
           
        });
        $('#builderConcession').on('blur', function (e) {
           
            if ($(this).val() == "") {
                $(this).val("0.000");
            }
        });
        $('#cmgBonus').on('focus', function (e) {
            if ($(this).val() == "0.000") {
                $(this).val("");
            }

        });
        $('#cmgBonus').on('blur', function (e) {

            if ($(this).val() == "") {
                $(this).val("0.000");
            }
        });
        $('#cmgBonusGov').on('focus', function (e) {
            if ($(this).val() == "0.000") {
                $(this).val("");
            }

        });
        $('#cmgBonusGov').on('blur', function (e) {

            if ($(this).val() == "") {
                $(this).val("0.000");
            }
        });
       
       
        $('#multi').change(function () {
            if (this.checked) {
                $('#div-multi').css("display", "block");
                document.getElementById("noUnits").attr('required', '');
            } else {
                $('#div-multi').css("display", "none");
                $("#noUnits").removeAttr('required');
                document.getElementById("hdnNoOfUnits").value = 1;
            }
        });
        
        $('#btnSearch').click(function (e) {
            e.preventDefault();
            if ($('#search-form').valid()) {

                if ($('#multi').is(":checked")) {
                    var n = document.getElementById("hdnNoOfUnits").value;
                    if (n < 2) {
                        alert("Please select the No. of Units");
                        return false;
                    }
                }
                var form = new FormData();

                //form.append("loandiscountedpoints", document.getElementById('loandiscountedpoints').value);
                form.append("builderconcession", document.getElementById('builderConcession').value);
                form.append("cmgbonus", document.getElementById('cmgBonus').value);
                form.append("cmgbonusgov", document.getElementById('cmgBonusGov').value);
                form.append("salesprice", document.getElementById('salesinput').value);
                //alert(document.getElementById('hdnNoOfUnits').value);
                form.append("lockTerm", document.getElementById('hdnLockTerm').value);
                form.append("noUnits", document.getElementById('hdnNoOfUnits').value);
                
                form.append("propertytype", $("input:radio[name='propertytype']:checked").val());
               // form.append("contribution_cmg", document.getElementById('contribution_CMG').value);
                //form.append("contribution_agent", document.getElementById('contribution_Agent').value);
                //form.append("contribution_agent", "0.00");
                var loc1 = getCookie("speclock_prefix_url");
                $.ajax({
                    url: loc1 + '/get-rate-options',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                       
                        if (response == "ok") {
                            window.location.href = loc1 + '/search-rate-result';
                        }
                        else if (response == "nodata") {
                            window.location.href = loc1 + '/search-rate-result';
                        }
                        else {
                            window.location.href = loc1;
                        }
                    }
                });
            }
            else
                return false;

        });              
    }
      
    if ($('#speclock_search_rate_result_page').length) {
        $(document).ready(function () {
            var $loading = $('#ll_loading-div').hide();
            var loc1 = $("#prefixurl").val();

        
         
            $(document).on("click", ".popover .close", function () {
                $(this).parents(".popover").popover('hide');
            });

            var genericCloseBtnHtml = '<button onclick="$(this).closest(\'div.popover\').popover(\'hide\');" type="button" class="close" aria-hidden="true">&times;</button>';

            $('[data-toggle = "popover"]').popover({
                html: true,
                title: 'Repayment' + genericCloseBtnHtml,
                content: function () {
               return $(this).next('.popper-content').html();
            }
            });

            $('[data-toggle="popover"]').on('click', function (e) {
                $('[data-toggle="popover"]').not(this).popover('hide');
            });
            $('[data-toggle="tooltip"]').tooltip();

            var formnew = new FormData();
           // formnew.append("loan-number", $("#loan-number").val());
            formnew.append("loan-program", $("#hdnLP").val());
            LoadDownpayments(formnew);

            $('#new-loanprogram').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                var valueSelected = this.value;
                var textSelected = optionSelected.text()

                var formnew = new FormData();
                formnew.append("loan-number", $("#loan-number").val());
                formnew.append("loan-program", textSelected);


                LoadDownpayments(formnew);


            });

            function LoadDownpayments(formnew) {


                $.ajax({
                    url: 'get-downpayments-for-loanprogram-result',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formnew,
                    beforeSend: function () {
                        // $loading.show();
                        $("#loading-img-featured").removeClass("d-none");
                    },
                    success: function (response) {
                        $("#loading-img-featured").addClass("d-none");
                        if (response.success) {
                            $('#new-downpayment').empty();
                            $('#new-downpayment').append(new Option("-select-", ""));
                            for (var i = 0; i < response.data.length; i++) {
                                $('#new-downpayment').append(new Option((response.data[i] * 100).toFixed(2).toString(), response.data[i]));
                            }

                        }

                    }
                });

            }

            $('#new-downpayment').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                var valueSelected = this.value;
                var textSelected = optionSelected.text()

                var formnew = new FormData();
               // formnew.append("loan-number", $("#loan-number").val());
                formnew.append("loan-program", $("#new-loanprogram option:selected").val());
                formnew.append("down-payment", valueSelected);


                $.ajax({
                    url: 'get-ficoscores-for-loanprogram-result',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formnew,
                    beforeSend: function () {
                        $("#loading-img-featured").removeClass("d-none");
                    },
                    success: function (response) {
                        $("#loading-img-featured").addClass("d-none");
                        if (response.success) {
                            $("#fico-div").show();
                            $("#featured-button-div").show();
                            $('#new-fico').empty();
                            $('#new-fico').append(new Option("-select-", ""));
                            for (var i = 0; i < response.data.length; i++) {
                                $('#new-fico').append(new Option(response.data[i].key, response.data[i].value));
                            }

                        }

                    }
                });


            });

            $('#new-fico').on('change', function (e) {
                var optionSelected = $("option:selected", this);
                var valueSelected = this.value;
                var textSelected = optionSelected.text()
                var formnew = new FormData();
                // formnew.append("loan-number", $("#loan-number").val());
                formnew.append("loan-program", $("#new-loanprogram option:selected").val());
                formnew.append("down-payment", $('#new-downpayment option:selected').val());
                formnew.append("fico-scores", textSelected);


                $.ajax({
                    url: 'get-loan-program-code-result',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formnew,
                    beforeSend: function () {
                        $("#loading-img-featured").removeClass("d-none");
                    },
                    success: function (response) {
                        $("#loading-img-featured").addClass("d-none");
                        if (response.success) {
                            $("#hdnloanprogramcode").val(response.data);
                       
                        }

                    }
                });


            });

            $('#update_featured').click(function (e) {

                e.preventDefault();
                var confirmationNumber = $('#hdnConfirmationNumber').val();

                $("#loading-img-featured").removeClass("d-none");
                $('#featured_update_error_message').removeClass('d-none');
                $('#featured_rate_form').parent().addClass('d-none');
                var postUrl = `update-featured-result?loanprogram=${$("#new-loanprogram option:selected").val()}&downpayment=${$("#new-downpayment option:selected").val()}&ficoscore=${$("#new-fico option:selected").text()}&lockrate=${$("#new-fico option:selected").val()}&programCode=${$("#hdnloanprogramcode").val()}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                        $("#loading-img-featured").addClass("d-none");
                      //  window.location.href = loc1 + "/purchase-information";
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#featured_update_error_message').removeClass('d-none');
                        $('#featured_rate_form').parent().removeClass('d-none');
                        $('#loading-img-featured').addClass('d-none');
                    });


            });
        });
      
        
    }

    if ($('#ll_property_page').length) {
               
        $(document).ready(function () {

            $(document).on("click", ".popover .close", function () {
                $(this).parents(".popover").popover('hide');
            });
            var genericCloseBtnHtml = '<button onclick="$(this).closest(\'div.popover\').popover(\'hide\');" type="button" class="close" aria-hidden="true">&times;</button>';

            $('[data-toggle="popover"]').popover({
                html: true,               
                content: function () {
                    return $(this).next('.popper-content').html();
                }
            });
            $('[data-toggle="popover"]').on('click', function (e) {
                $('[data-toggle="popover"]').not(this).popover('hide');
            });
            $('[data-toggle="tooltip"]').tooltip();
        });
    }

   

    if ($('#speclock_payment_page').length) {

        var $loadingConfirm = $('#confirm-spec-lock-loading').hide();

        $('#btnConfirmLock').click(function (e) {

            e.preventDefault();
            var loc = $("#prefixurl").val();
            //$.ajax({
            //    url: loc + '/CreateSpecLockLoan',
            //    type: 'POST',
            //    cache: false,
            //    contentType: false,
            //    processData: false,
            //    data: "",
            //    beforeSend: function () {
            //        $loadingConfirm.show();
            //    },
            //    success: function (response) {
            //        $loadingConfirm.hide();
            //        if (response.success) {
            //            console.log('redirecting to ' + response.redirectUrl);
            //            window.location.href = response.redirectUrl;
            //        }                   
            //    },
            //    fail: function (response) {
            //        window.location.href = window.location.origin + window.location.pathname +'/confirmation-backup';
            //    }

            //});
            $loadingConfirm.show();
            $.post(loc + '/CreateSpecLockLoan')
                .done(function (data) {
                    $loadingConfirm.hide();
                    if (data.success) {
                        console.log('redirecting to ' + data.redirectUrl);
                        window.location.href = data.redirectUrl;
                    }
                    else {
                        window.location.href = window.location.origin + window.location.pathname + '/confirmation-backup';
                    }
                   
                })
                .fail(function (xhr, status, error) {
                    $loadingConfirm.hide();
                    window.location.href = window.location.origin + window.location.pathname + '/confirmation-backup';
                });

            setTimeout(() => {
                location.reload();
            }, 300000);
        });
            }
});

function createLoan(url, retryAttempt) {

    $.post(url)
        .done(function (data) {
            if (data.success) {
                console.log('redirecting to ' + data.redirectUrl);
                window.location.href = data.redirectUrl;
            }
            else {
                $('.label-error').removeClass('d-none');
                $('.dev-error h6').text(data.errorMessage);
                $('.label').addClass('d-none');
                $('img').addClass('d-none');
            }
        })
        .fail(function (xhr, status, error) {
            if (xhr.status === 503) {
                alert.log('error 503')
                retryAttempt++;
                if (retryAttempt < 4) {
                    createLoan(returnUrl, retryAttempt);
                    return;
                }
            }
          
            $('.label-error').removeClass('d-none');
            $('.dev-error h6').text(`Communication error. xhr: ${JSON.stringify(xhr)}, status: ${JSON.stringify(status)} error: ${JSON.stringify(error)}`);
            $('.label').addClass('d-none');
            $('img').addClass('d-none');
        });

    setTimeout(() => {
        location.reload();
    }, 300000);
}
